import { render, staticRenderFns } from "./ConfirmBulkDeleteModal.vue?vue&type=template&id=2adfd88c"
import script from "./ConfirmBulkDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmBulkDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports